<template>
  <div id="forgot-password">
    <!-- Step 2 : Change Password-->
    <div id="change-password">
      <h2>{{ $t('resetting_a_password') }}</h2>
      <form @submit.prevent="onChangePassword()" method="post">
        <p class="small-txt mb10">{{ $t('please_enter_the_verification_code') }}</p>
        <input
          type="text"
          autocomplete="nope"
          class="mb20"
          v-model="changePassword.code"
          :class="[$v.changePassword.code.$error ? 'input-error' : '']"
        >
        <div v-if="changePasswordSubmitted && $v.changePassword.code.$error">
          <p class="error-txt mb20" v-if="!$v.changePassword.code.required">{{ $t('please_enter_the_verification_code') }}</p>
          <p class="error-txt mb20" v-else>{{ $t('the_verification_code_is_different') }}</p>
        </div>

        <p class="small-txt mb10">{{ $t('please_enter_a_new_password') }}</p>
        <input
          type="password"
          autocomplete="new-password"
          class="mb20"
          v-model="changePassword.password"
          :class="[$v.changePassword.password.$error ? 'pwd-error' : '']"
        >
        <div v-if="changePasswordSubmitted && $v.changePassword.password.$error">
          <p class="error-txt mb20" v-if="!$v.changePassword.password.required">{{ $t('please_enter_a_new_password') }}</p>
          <p class="error-txt mb20" v-else>{{ $t('input_format') }}</p>
        </div>

        <p class="small-txt mb10">{{ $t('confirm_new_password') }}</p>
        <input
          type="password"
          class="mb20"
          v-model="changePassword.confirmPassword"
          :class="[$v.changePassword.confirmPassword.$error ? 'pwd-error' : '']"
        >
        <div v-if="changePasswordSubmitted && $v.changePassword.confirmPassword.$error">
          <p class="error-txt mb20" v-if="!$v.changePassword.confirmPassword.required">{{ $t('please_enter_a_new_password_to_confirm') }}</p>
          <p class="error-txt mb20" v-else>{{ $t('the_passwords_do_not_match') }}</p>
        </div>

        <div class="mb10">
          <p class="error-txt mb10" v-if="changePasswordSubmitted && !$v.changePassword.code.$error
          && !$v.changePassword.password.$error && !$v.changePassword.confirmPassword.$error">{{ errorChangePassword }}</p>
        </div>
        <button class="btn-base mb20" type="submit" style="border: #ffa300"><a><p>{{ $t('resetting_a_password') }}</p></a></button>
        <div class="btn-cancel" @click="onCancel()"><a href="#"><p>{{ $t('cancel') }}</p></a></div>
      </form>
    </div>
  </div>
</template>

<script>
  import { required, sameAs, numeric } from "vuelidate/lib/validators"
  import checkStrengthPassword from '@/js/commons/checkStrengthPassword'
  import { Strings } from "@/js/commons/strings"
  import { mapState } from 'vuex'

  export default {
    data() {
      return {
        Strings: Strings,
        changePassword: {
          code: '',
          password: '',
          confirmPassword: ''
        },
        changePasswordSubmitted: false
      }
    },
    validations: {
      changePassword: {
        code: { required, numeric },
        password: { required, checkStrengthPassword },
        confirmPassword: { required, sameAsPassword: sameAs('password') }
      }
    },
    computed: {
      ...mapState({
        emailReset: state => state.auth.emailReset,
        errorChangePassword: state => state.auth.errorChangePassword
      })
    },
    mounted() {
      this.screenTracking(this.$t('pw_reset_forgot'))
      if (this.$store.state.auth.emailReset === '') {
        this.$router.push({ path: '/send-reset-link' }).catch(err => {})
      }
    },
    methods: {
      onCancel() {
        this.$router.push({ path: '/send-reset-link' }).catch(err => {})
      },
      async onChangePassword() {
        this.changePasswordSubmitted = true
        this.$v.changePassword.$touch()
        if (this.$v.changePassword.$error) return
        else {
          const params = {
            code: this.changePassword.code,
            username: this.emailReset,
            password: this.changePassword.password
          }
          await this.$store.dispatch('auth/resetPassword', params)

          if(!this.errorChangePassword){
           this.$router.push({ path: '/changed-password' }).catch(err => { console.log(err) })
          }
        }
      }
    }
  }
</script>